import {IIncident, Impact} from "../../rz-status_models";
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm';
import remarkBreaks  from 'remark-breaks';

export default function({incident, worst = false, detail = false}: {incident: IIncident, worst?: boolean, detail?: boolean}) {
	return <tr className="responsive">
		<th className="application">{incident.serviceId.name}</th>
    	<DateElement date={incident.startDate} className="start"/>
		<DateElement date={incident.endDate} className="end"/>
		<StateIcon state={worst ? incident.worstState : incident.currentState}/>

		{(detail && incident.externalInfo) ? <th className="details">
			<Markdown remarkPlugins={[remarkBreaks,remarkGfm]}>{incident.externalInfo}</Markdown>
		</th> : ""}
    </tr>
}

function DateElement({date, className}) {
    if ((!date) || (date == null) || (date.getTime() === 0) || (date.getFullYear() === 0))
        return <td className={"date nodate " + className}>-</td>;
	return  <td className={"date " + className}>{moment(date).local(true).format("DD.MM.YYYY / HH:mm")}</td>
}


function StateIcon({state} : {state: Impact}) {
	let stateString = "state_ok"
	if(state == Impact.Limited) {
		stateString = "state_problem"
	}
	else if(state == Impact.Outage) {
		stateString = "state_notok"
	}

	return <td className="state"><span className={"icon " + stateString}> </span></td>
}
